// // src/pages/Relatorios/RelatorioEquipamentos.tsx

// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Form, Button, Spinner, Modal, Tabs, Tab } from 'react-bootstrap';
// import {
//   FaTrophy, FaArrowDown, FaTv, FaSync, FaChartLine, FaChartBar,
//   FaExclamationTriangle, FaEye, FaUsers, FaMoneyBillWave,
// } from 'react-icons/fa';
// import {
//   BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
//   Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell,
// } from 'recharts';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// import { PageHeader } from '../../components/shared/PageHeader';
// import { KpiCards }   from '../../components/shared/KpiCard';
// import { DataTable }  from '../../components/shared/DataTable';

// // ── Categorias (mesmas do cadastro de equipamentos) ──
// const CATEGORIAS = ['Outdoor LED', 'Outdoor Lona', 'Busdoor', 'Indoor', 'Frontlight'];

// // 🎨 Paleta oficial do sistema (mesma do Dashboard)
// const CHART_COLORS = ['#4361ee', '#3f37c9', '#7209b7', '#f72585', '#4cc9f0', '#f8961e', '#6c757d'];
// const COR_PRIMARIA = '#4361ee';
// const COR_SUCESSO  = '#4cc9f0';
// const COR_ALERTA   = '#f8961e';
// const COR_PERIGO   = '#f72585';

// // ── Tipos ──
// interface Filters {
//   startDate: string;
//   endDate:   string;
//   limit:     number;
//   category:  string;
// }

// interface MonthlyPoint {
//   month:   string;
//   revenue: number;
// }

// interface EquipmentRow {
//   equipmentId:     string;
//   name:            string;
//   identifierCode:  string;
//   category:        string;
//   location:        string;
//   slots:           number;
//   isActive:        boolean;
//   ordersCount:     number;
//   totalRevenue:    number;
//   totalDaysRented: number;
//   paidRevenue:     number;
//   pendingRevenue:  number;
//   overdueRevenue:  number;
//   uniqueCustomers: number;
//   avgTicket:       number;
//   defaultRate:     number;
//   monthlyRevenue:  MonthlyPoint[];
// }

// interface CategoryRow {
//   category:        string;
//   equipmentsCount: number;
//   totalRevenue:    number;
//   totalOrders:     number;
// }

// interface ReportData {
//   period: { startDate: string | null; endDate: string | null };
//   summary: {
//     totalEquipments:        number;
//     equipmentsActive:       number;
//     equipmentsWithSales:    number;
//     equipmentsWithoutSales: number;
//     totalOrders:            number;
//     totalRevenue:           number;
//     totalPaid:              number;
//     totalPending:           number;
//     totalOverdue:           number;
//     avgTicket:              number;
//     avgRevenuePerEquipment: number;
//     defaultRate:            number;
//   };
//   topSelling:       EquipmentRow[];
//   leastSelling:     EquipmentRow[];
//   byCategory:       CategoryRow[];
//   monthlyEvolution: MonthlyPoint[];
//   allEquipments:    EquipmentRow[];
// }

// const EMPTY_FILTERS: Filters = { startDate: '', endDate: '', limit: 10, category: '' };

// // ── Helpers ──
// const formatCurrency = (v: number) =>
//   new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

// const formatNumber  = (v: number) => (v ?? 0).toLocaleString('pt-BR');
// const formatPercent = (v: number) => `${(v ?? 0).toFixed(1)}%`;
// const formatMonth   = (m: string) => {
//   const [y, mo] = m.split('-');
//   return `${mo}/${y.slice(2)}`;
// };

// // ── Tag de categoria (substitui Badge) ──
// const CategoryTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
//   <span
//     className="d-inline-block px-2 py-1 rounded-pill small fw-medium"
//     style={{
//       backgroundColor: '#f1f3f5',
//       color: '#495057',
//       border: '1px solid #e9ecef',
//     }}
//   >
//     {children}
//   </span>
// );

// // ── Tag de inadimplência (substitui Badge colorido) ──
// const DefaultRateTag: React.FC<{ rate: number }> = ({ rate }) => {
//   const isHigh = rate > 20;
//   const color  = isHigh ? COR_PERIGO : COR_ALERTA;

//   return (
//     <span
//       className="d-inline-block px-2 py-1 rounded small fw-semibold"
//       style={{
//         backgroundColor: `${color}15`,
//         color,
//         border: `1px solid ${color}30`,
//       }}
//     >
//       {formatPercent(rate)}
//     </span>
//   );
// };

// // ── Numerador de ranking (substitui Badge pill) ──
// const RankNumber: React.FC<{ position: number; variant: 'top' | 'bottom' }> = ({ position, variant }) => {
//   const color = variant === 'top' ? COR_PRIMARIA : '#6c757d';
//   return (
//     <span
//       className="d-inline-flex align-items-center justify-content-center fw-bold"
//       style={{
//         width: 28,
//         height: 28,
//         borderRadius: '50%',
//         backgroundColor: `${color}15`,
//         color,
//         fontSize: 13,
//       }}
//     >
//       {position}
//     </span>
//   );
// };

// // ==========================================
// export default function RelatorioEquipamentos() {
//   const [report,            setReport]            = useState<ReportData | null>(null);
//   const [loading,           setLoading]           = useState<boolean>(true);
//   const [filters,           setFilters]           = useState<Filters>(EMPTY_FILTERS);
//   const [selectedEquipment, setSelectedEquipment] = useState<EquipmentRow | null>(null);

//   const fetchReport = async (activeFilters: Filters = filters) => {
//     try {
//       setLoading(true);
//       const params: Record<string, any> = {};
//       if (activeFilters.startDate) params.startDate = activeFilters.startDate;
//       if (activeFilters.endDate)   params.endDate   = activeFilters.endDate;
//       if (activeFilters.limit)     params.limit     = activeFilters.limit;
//       if (activeFilters.category)  params.category  = activeFilters.category;

//       const response = await api.get('/reports/equipments/sales', { params });
//       setReport(response.data);
//     } catch {
//       toast.error('Erro ao carregar relatório de equipamentos.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { fetchReport(EMPTY_FILTERS); }, []);

//   const handleFilterChange = (e: any) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: name === 'limit' ? Number(value) : value,
//     }));
//   };

//   const handleApply = () => fetchReport(filters);
//   const handleClear = () => { setFilters(EMPTY_FILTERS); fetchReport(EMPTY_FILTERS); };

//   const summary = report?.summary;

//   // ── KPIs ──
//   const kpiItems = [
//     { label: 'Receita Total',     value: formatCurrency(summary?.totalRevenue ?? 0),           color: 'success' },
//     { label: 'Total de Pedidos',  value: formatNumber(summary?.totalOrders ?? 0),              color: 'primary' },
//     { label: 'Ticket Médio',      value: formatCurrency(summary?.avgTicket ?? 0),              color: 'info'    },
//     { label: 'Receita Média/Eq.', value: formatCurrency(summary?.avgRevenuePerEquipment ?? 0), color: 'warning' },
//   ];

//   const kpiItemsRow2 = [
//     { label: 'Equipamentos Ativos', value: formatNumber(summary?.equipmentsActive ?? 0),       color: 'success'   },
//     { label: 'Com Vendas',          value: formatNumber(summary?.equipmentsWithSales ?? 0),    color: 'primary'   },
//     { label: 'Sem Vendas',          value: formatNumber(summary?.equipmentsWithoutSales ?? 0), color: 'secondary' },
//     {
//       label: 'Taxa de Inadimplência',
//       value: formatPercent(summary?.defaultRate ?? 0),
//       color: (summary?.defaultRate ?? 0) > 10 ? 'danger' : 'warning',
//     },
//   ];

//   // ── Pizza de status financeiro (paleta do sistema) ──
//   const financialStatusData = summary ? [
//     { name: 'Pago',      value: summary.totalPaid,    color: COR_PRIMARIA },
//     { name: 'Pendente',  value: summary.totalPending, color: COR_ALERTA   },
//     { name: 'Em Atraso', value: summary.totalOverdue, color: COR_PERIGO   },
//   ].filter(d => d.value > 0) : [];

//   return (
//     <Container fluid className="p-4">

//       <PageHeader
//         title="Relatório de Equipamentos"
//         buttonLabel="Atualizar"
//         buttonIcon={FaSync}
//         onButtonClick={() => fetchReport(filters)}
//         subtitle={undefined}
//         children={undefined}
//       />

//       <Row className="mb-3">
//         <KpiCards items={kpiItems} colSize={3} />
//       </Row>
//       <Row className="mb-4">
//         <KpiCards items={kpiItemsRow2} colSize={3} />
//       </Row>

//       {/* ── Filtros ── */}
//       <Card className="mb-4 shadow-sm">
//         <Card.Body>
//           <Row className="g-3 align-items-end">
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label className="small fw-semibold">Data Inicial</Form.Label>
//                 <Form.Control type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label className="small fw-semibold">Data Final</Form.Label>
//                 <Form.Control type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
//               </Form.Group>
//             </Col>
//             <Col md={3}>
//               <Form.Group>
//                 <Form.Label className="small fw-semibold">Categoria</Form.Label>
//                 <Form.Select name="category" value={filters.category} onChange={handleFilterChange}>
//                   <option value="">Todas as categorias</option>
//                   {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label className="small fw-semibold">Top N</Form.Label>
//                 <Form.Select name="limit" value={filters.limit} onChange={handleFilterChange}>
//                   <option value={5}>Top 5</option>
//                   <option value={10}>Top 10</option>
//                   <option value={20}>Top 20</option>
//                   <option value={50}>Top 50</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={3} className="d-flex gap-2">
//               <Button variant="primary" onClick={handleApply} disabled={loading}>
//                 {loading ? <Spinner size="sm" animation="border" /> : 'Aplicar'}
//               </Button>
//               <Button variant="outline-secondary" onClick={handleClear} disabled={loading}>
//                 Limpar
//               </Button>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* ── Tabs ── */}
//       <Tabs defaultActiveKey="overview" className="mb-3" mountOnEnter>

//         {/* ─── ABA: Visão Geral ─── */}
//         <Tab eventKey="overview" title={<><FaChartLine className="me-2" />Visão Geral</>}>

//           <Card className="mb-4 shadow-sm">
//             <Card.Header className="bg-white fw-semibold">
//               <FaChartLine className="me-2" style={{ color: COR_PRIMARIA }} />
//               Evolução de Faturamento Mensal
//             </Card.Header>
//             <Card.Body>
//               {report && report.monthlyEvolution.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={300}>
//                   <LineChart data={report.monthlyEvolution.map(m => ({ ...m, monthLabel: formatMonth(m.month) }))}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="monthLabel" />
//                     <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
//                     <Tooltip formatter={(v: number) => formatCurrency(v)} />
//                     <Legend />
//                     <Line type="monotone" dataKey="revenue" name="Receita" stroke={COR_PRIMARIA} strokeWidth={3} dot={{ r: 5 }} activeDot={{ r: 7 }} />
//                   </LineChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <p className="text-center text-muted my-4">Sem dados para exibir.</p>
//               )}
//             </Card.Body>
//           </Card>

//           <Row className="g-3 mb-4">
//             <Col lg={7}>
//               <Card className="shadow-sm h-100">
//                 <Card.Header className="bg-white fw-semibold">
//                   <FaChartBar className="me-2" style={{ color: COR_SUCESSO }} />
//                   Faturamento por Categoria
//                 </Card.Header>
//                 <Card.Body>
//                   {report && report.byCategory.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={300}>
//                       <BarChart data={report.byCategory}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="category" />
//                         <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
//                         <Tooltip formatter={(v: number) => formatCurrency(v)} />
//                         <Bar dataKey="totalRevenue" name="Receita" radius={[8, 8, 0, 0]}>
//                           {report.byCategory.map((_, i) => (
//                             <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
//                           ))}
//                         </Bar>
//                       </BarChart>
//                     </ResponsiveContainer>
//                   ) : (
//                     <p className="text-center text-muted my-4">Sem dados para exibir.</p>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>

//             <Col lg={5}>
//               <Card className="shadow-sm h-100">
//                 <Card.Header className="bg-white fw-semibold">
//                   <FaMoneyBillWave className="me-2" style={{ color: COR_ALERTA }} />
//                   Status Financeiro
//                 </Card.Header>
//                 <Card.Body>
//                   {financialStatusData.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={300}>
//                       <PieChart>
//                         <Pie
//                           data={financialStatusData}
//                           dataKey="value"
//                           nameKey="name"
//                           cx="50%"
//                           cy="50%"
//                           outerRadius={100}
//                           label={({ name, percent }) => `${name} ${((percent ?? 0) * 100).toFixed(0)}%`}
//                         >
//                           {financialStatusData.map((entry, i) => (
//                             <Cell key={i} fill={entry.color} />
//                           ))}
//                         </Pie>
//                         <Tooltip formatter={(v: number) => formatCurrency(v)} />
//                       </PieChart>
//                     </ResponsiveContainer>
//                   ) : (
//                     <p className="text-center text-muted my-4">Sem dados financeiros.</p>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {report && report.byCategory.length > 0 && (
//             <Card className="shadow-sm mb-4">
//               <Card.Header className="bg-white fw-semibold">📊 Resumo por Categoria</Card.Header>
//               <Card.Body className="p-0">
//                 <DataTable
//                   columns={['Categoria', 'Equipamentos', 'Pedidos', 'Receita Total', '% do Total']}
//                   loading={false}
//                   emptyMessage=""
//                 >
//                   {report.byCategory.map(c => {
//                     const pct = summary && summary.totalRevenue > 0
//                       ? (c.totalRevenue / summary.totalRevenue) * 100
//                       : 0;
//                     return (
//                       <tr key={c.category}>
//                         <td className="fw-semibold">{c.category}</td>
//                         <td>{c.equipmentsCount}</td>
//                         <td>{c.totalOrders}</td>
//                         <td className="fw-semibold">{formatCurrency(c.totalRevenue)}</td>
//                         <td>
//                           <div className="d-flex align-items-center gap-2">
//                             <div className="progress flex-grow-1" style={{ height: 8 }}>
//                               <div
//                                 className="progress-bar"
//                                 style={{ width: `${pct}%`, backgroundColor: COR_PRIMARIA }}
//                               />
//                             </div>
//                             <small className="text-muted">{pct.toFixed(1)}%</small>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </DataTable>
//               </Card.Body>
//             </Card>
//           )}
//         </Tab>

//         {/* ─── ABA: Rankings ─── */}
//         <Tab eventKey="rankings" title={<><FaTrophy className="me-2" />Rankings</>}>
//           <Row className="g-3">
//             <Col lg={6}>
//               <RankingCard
//                 title="Mais Vendidos"
//                 icon={<FaTrophy />}
//                 color="success"
//                 rows={report?.topSelling ?? []}
//                 loading={loading}
//                 variant="top"
//                 onSelect={setSelectedEquipment}
//               />
//             </Col>
//             <Col lg={6}>
//               <RankingCard
//                 title="Menos Vendidos"
//                 icon={<FaArrowDown />}
//                 color="danger"
//                 rows={report?.leastSelling ?? []}
//                 loading={loading}
//                 variant="bottom"
//                 onSelect={setSelectedEquipment}
//               />
//             </Col>
//           </Row>
//         </Tab>

//         {/* ─── ABA: Tabela Detalhada ─── */}
//         <Tab eventKey="detailed" title={<><FaTv className="me-2" />Detalhado</>}>
//           <Card className="shadow-sm">
//             <Card.Header className="bg-white fw-semibold">
//               📋 Todos os Equipamentos ({report?.allEquipments.length ?? 0})
//             </Card.Header>
//             <Card.Body className="p-0">
//               <DataTable
//                 columns={['Equipamento', 'Categoria', 'Pedidos', 'Clientes', 'Receita', 'Ticket Médio', 'Inadimpl.', 'Ações']}
//                 loading={loading}
//                 emptyMessage="Nenhum equipamento encontrado."
//               >
//                 {(report?.allEquipments ?? []).map(eq => (
//                   <tr key={eq.equipmentId}>
//                     <td>
//                       <div className="fw-semibold">{eq.name}</div>
//                       <small className="text-muted">
//                         <code>{eq.identifierCode}</code> · 📍 {eq.location}
//                       </small>
//                     </td>
//                     <td><CategoryTag>{eq.category}</CategoryTag></td>
//                     <td className="text-center">{eq.ordersCount}</td>
//                     <td className="text-center">
//                       <FaUsers className="me-1 text-muted" />{eq.uniqueCustomers}
//                     </td>
//                     <td className="fw-semibold">{formatCurrency(eq.totalRevenue)}</td>
//                     <td>{formatCurrency(eq.avgTicket)}</td>
//                     <td>
//                       {eq.defaultRate > 0 ? (
//                         <DefaultRateTag rate={eq.defaultRate} />
//                       ) : (
//                         <span className="text-muted small">—</span>
//                       )}
//                     </td>
//                     <td>
//                       <Button size="sm" variant="outline-primary" onClick={() => setSelectedEquipment(eq)} disabled={eq.ordersCount === 0}>
//                         <FaEye />
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//               </DataTable>
//             </Card.Body>
//           </Card>
//         </Tab>

//         {/* ─── ABA: Inadimplência ─── */}
//         <Tab eventKey="overdue" title={<><FaExclamationTriangle className="me-2" />Inadimplência</>}>
//           <Card className="shadow-sm">
//             <Card.Header className="bg-white fw-semibold text-danger">
//               <FaExclamationTriangle className="me-2" />
//               Equipamentos com Inadimplência
//             </Card.Header>
//             <Card.Body className="p-0">
//               <DataTable
//                 columns={['Equipamento', 'Categoria', 'Receita Total', 'Em Atraso', 'Taxa Inadimpl.']}
//                 loading={loading}
//                 emptyMessage="🎉 Nenhuma inadimplência detectada!"
//               >
//                 {(report?.allEquipments ?? [])
//                   .filter(eq => eq.overdueRevenue > 0)
//                   .sort((a, b) => b.overdueRevenue - a.overdueRevenue)
//                   .map(eq => (
//                     <tr key={eq.equipmentId}>
//                       <td>
//                         <div className="fw-semibold">{eq.name}</div>
//                         <small className="text-muted"><code>{eq.identifierCode}</code></small>
//                       </td>
//                       <td><CategoryTag>{eq.category}</CategoryTag></td>
//                       <td>{formatCurrency(eq.totalRevenue)}</td>
//                       <td className="text-danger fw-bold">{formatCurrency(eq.overdueRevenue)}</td>
//                       <td><DefaultRateTag rate={eq.defaultRate} /></td>
//                     </tr>
//                   ))}
//               </DataTable>
//             </Card.Body>
//           </Card>
//         </Tab>

//       </Tabs>

//       <EquipmentDetailModal
//         equipment={selectedEquipment}
//         onClose={() => setSelectedEquipment(null)}
//       />
//     </Container>
//   );
// }

// // ==========================================
// // CARD DE RANKING
// // ==========================================
// interface RankingCardProps {
//   title:    string;
//   icon:     React.ReactNode;
//   color:    string;
//   rows:     EquipmentRow[];
//   loading:  boolean;
//   variant:  'top' | 'bottom';
//   onSelect: (eq: EquipmentRow) => void;
// }

// function RankingCard({ title, icon, color, rows, loading, variant, onSelect }: RankingCardProps) {
//   return (
//     <Card className="border-0 shadow-sm h-100">
//       <Card.Header className={`bg-${color} bg-opacity-10 text-${color} fw-semibold d-flex align-items-center gap-2`}>
//         {icon} {title}
//       </Card.Header>
//       <Card.Body className="p-0">
//         <DataTable
//           columns={['#', 'Equipamento', 'Pedidos', 'Receita', 'Ações']}
//           loading={loading}
//           emptyMessage="Nenhum equipamento encontrado."
//         >
//           {rows.length > 0 && rows.map((row, idx) => (
//             <tr key={row.equipmentId}>
//               <td className="text-center">
//                 <RankNumber position={idx + 1} variant={variant} />
//               </td>
//               <td>
//                 <div className="fw-semibold d-flex align-items-center gap-2">
//                   <FaTv className="text-muted" />
//                   {row.name}
//                 </div>
//                 <small className="text-muted">
//                   <code>{row.identifierCode}</code> · {row.category}
//                 </small>
//               </td>
//               <td className="text-center">
//                 <span className="fw-bold" style={{ color: row.ordersCount === 0 ? COR_PERIGO : undefined }}>
//                   {row.ordersCount}
//                 </span>
//               </td>
//               <td className="fw-semibold">{formatCurrency(row.totalRevenue)}</td>
//               <td>
//                 <Button size="sm" variant="outline-primary" onClick={() => onSelect(row)} disabled={row.ordersCount === 0}>
//                   <FaEye />
//                 </Button>
//               </td>
//             </tr>
//           ))}
//         </DataTable>
//       </Card.Body>
//     </Card>
//   );
// }

// // ==========================================
// // MODAL DE DETALHE
// // ==========================================
// interface DetailModalProps {
//   equipment: EquipmentRow | null;
//   onClose:   () => void;
// }

// function EquipmentDetailModal({ equipment, onClose }: DetailModalProps) {
//   if (!equipment) return null;

//   const monthlyData = equipment.monthlyRevenue.map(m => ({
//     ...m,
//     monthLabel: formatMonth(m.month),
//   }));

//   return (
//     <Modal show={!!equipment} onHide={onClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title className="d-flex align-items-center gap-2">
//           <FaTv />
//           {equipment.name}
//           <CategoryTag>{equipment.category}</CategoryTag>
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Row className="mb-3 g-2">
//           <Col md={3}>
//             <Card className="bg-primary bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Pedidos</small>
//               <h4 className="mb-0 text-primary">{equipment.ordersCount}</h4>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="bg-success bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Receita</small>
//               <h6 className="mb-0 text-success">{formatCurrency(equipment.totalRevenue)}</h6>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="bg-info bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Ticket Médio</small>
//               <h6 className="mb-0 text-info">{formatCurrency(equipment.avgTicket)}</h6>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="bg-warning bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Clientes</small>
//               <h4 className="mb-0 text-warning">{equipment.uniqueCustomers}</h4>
//             </Card>
//           </Col>
//         </Row>

//         <h6 className="text-muted mb-3">
//           <FaChartBar className="me-2" />
//           Faturamento por Mês
//         </h6>
//         {monthlyData.length > 0 ? (
//           <ResponsiveContainer width="100%" height={250}>
//             <BarChart data={monthlyData}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="monthLabel" />
//               <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
//               <Tooltip formatter={(v: number) => formatCurrency(v)} />
//               <Bar dataKey="revenue" name="Receita" fill={COR_PRIMARIA} radius={[8, 8, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <p className="text-center text-muted my-3">Sem histórico mensal.</p>
//         )}

//         <hr />
//         <Row className="small">
//           <Col md={6}>
//             <strong>📍 Localização:</strong> {equipment.location}<br />
//             <strong>🔢 Código:</strong> <code>{equipment.identifierCode}</code><br />
//             <strong>🎯 Slots:</strong> {equipment.slots}
//           </Col>
//           <Col md={6}>
//             <strong>💰 Pago:</strong> <span className="text-success">{formatCurrency(equipment.paidRevenue)}</span><br />
//             <strong>⏳ Pendente:</strong> <span className="text-warning">{formatCurrency(equipment.pendingRevenue)}</span><br />
//             <strong>⚠️ Em atraso:</strong> <span className="text-danger">{formatCurrency(equipment.overdueRevenue)}</span>
//           </Col>
//         </Row>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onClose}>Fechar</Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

 //1406
// src/pages/Relatorios/RelatorioEquipamentos.tsx

// import React, { useState, useEffect, useRef } from 'react';
// import { Container, Row, Col, Card, Form, Button, Spinner, Modal, Tabs, Tab } from 'react-bootstrap';
// import {
//   FaTrophy, FaArrowDown, FaTv, FaSync, FaChartLine, FaChartBar,
//   FaExclamationTriangle, FaEye, FaUsers, FaMoneyBillWave,
//   FaThLarge, FaLock, FaMapMarkerAlt, FaMap, FaExpand, FaCompress,
// } from 'react-icons/fa';
// import {
//   BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
//   Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell,
// } from 'recharts';
// import { toast } from 'react-toastify';
// import api from '../../services/api';

// import { EquipmentMap } from '../../components/shared/EquipmentMap';

// import { PageHeader } from '../../components/shared/PageHeader';
// import { KpiCards }   from '../../components/shared/KpiCard';
// import { DataTable }  from '../../components/shared/DataTable';

// // ── Categorias (mesmas do cadastro de equipamentos) ──
// const CATEGORIAS = ['Outdoor LED', 'Outdoor Lona', 'Busdoor', 'Indoor', 'Frontlight'];

// // 🎨 Paleta oficial do sistema (mesma do Dashboard)
// const CHART_COLORS = ['#4361ee', '#3f37c9', '#7209b7', '#f72585', '#4cc9f0', '#f8961e', '#6c757d'];
// const COR_PRIMARIA = '#4361ee';
// const COR_SUCESSO  = '#4cc9f0';
// const COR_ALERTA   = '#f8961e';
// const COR_PERIGO   = '#f72585';

// // ── Tipos ──
// interface Filters {
//   startDate: string;
//   endDate:   string;
//   limit:     number;
//   category:  string;
// }

// interface MonthlyPoint {
//   month:   string;
//   revenue: number;
// }

// interface EquipmentRow {
//   equipmentId:     string;
//   name:            string;
//   identifierCode:  string;
//   category:        string;
//   location:        string;
//   slots:           number;
//   isActive:        boolean;
//   ordersCount:     number;
//   totalRevenue:    number;
//   totalDaysRented: number;
//   paidRevenue:     number;
//   pendingRevenue:  number;
//   overdueRevenue:  number;
//   uniqueCustomers: number;
//   avgTicket:       number;
//   defaultRate:     number;
//   monthlyRevenue:  MonthlyPoint[];
//   latitude:  number | null;
//   longitude: number | null;
// }

// interface CategoryRow {
//   category:        string;
//   equipmentsCount: number;
//   totalRevenue:    number;
//   totalOrders:     number;
// }

// interface ReportData {
//   period: { startDate: string | null; endDate: string | null };
//   summary: {
//     totalEquipments:        number;
//     equipmentsActive:       number;
//     equipmentsWithSales:    number;
//     equipmentsWithoutSales: number;
//     totalOrders:            number;
//     totalRevenue:           number;
//     totalPaid:              number;
//     totalPending:           number;
//     totalOverdue:           number;
//     avgTicket:              number;
//     avgRevenuePerEquipment: number;
//     defaultRate:            number;
//   };
//   topSelling:       EquipmentRow[];
//   leastSelling:     EquipmentRow[];
//   byCategory:       CategoryRow[];
//   monthlyEvolution: MonthlyPoint[];
//   allEquipments:    EquipmentRow[];
// }

// // ── Tipos de Slots ──
// interface SlotRow {
//   equipmentId:    string;
//   name:           string;
//   identifierCode: string;
//   category:       string;
//   location:       string;
//   totalSlots:     number;
//   occupiedSlots:  number;
//   availableSlots: number;
//   occupancyRate:  number;
//   nextAvailableDate: string | null; // 🆕 quando libera (se esgotado)
// }

// interface CategorySlot {
//   category:       string;
//   totalSlots:     number;
//   occupiedSlots:  number;
//   availableSlots: number;
//   occupancyRate:  number;
// }

// interface SlotsReport {
//   period: { startDate: string; endDate: string };
//   summary: {
//     totalEquipments: number;
//     totalSlots:      number;
//     totalOccupied:   number;
//     totalAvailable:  number;
//     occupancyRate:   number;
//   };
//   byCategory: CategorySlot[];
//   equipments: SlotRow[];
// }

// const EMPTY_FILTERS: Filters = { startDate: '', endDate: '', limit: 10, category: '' };

// // ── Helpers ──
// const formatCurrency = (v: number) =>
//   new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

// const formatNumber  = (v: number) => (v ?? 0).toLocaleString('pt-BR');
// const formatPercent = (v: number) => `${(v ?? 0).toFixed(1)}%`;
// const formatMonth   = (m: string) => {
//   const [y, mo] = m.split('-');
//   return `${mo}/${y.slice(2)}`;
// };

// // ── Tag de categoria (substitui Badge) ──
// const CategoryTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
//   <span
//     className="d-inline-block px-2 py-1 rounded-pill small fw-medium"
//     style={{
//       backgroundColor: '#f1f3f5',
//       color: '#495057',
//       border: '1px solid #e9ecef',
//     }}
//   >
//     {children}
//   </span>
// );

// // ── Tag de inadimplência (substitui Badge colorido) ──
// const DefaultRateTag: React.FC<{ rate: number }> = ({ rate }) => {
//   const isHigh = rate > 20;
//   const color  = isHigh ? COR_PERIGO : COR_ALERTA;

//   return (
//     <span
//       className="d-inline-block px-2 py-1 rounded small fw-semibold"
//       style={{
//         backgroundColor: `${color}15`,
//         color,
//         border: `1px solid ${color}30`,
//       }}
//     >
//       {formatPercent(rate)}
//     </span>
//   );
// };

// // ── Tag de disponibilidade de slots ── 🆕 agora mostra a data de liberação
// const AvailabilityTag: React.FC<{ available: number; nextDate?: string | null }> = ({
//   available,
//   nextDate,
// }) => {
//   const color = available === 0 ? COR_PERIGO : available <= 2 ? COR_ALERTA : COR_SUCESSO;

//   let label: string;
//   if (available === 0) {
//     label = nextDate
//       ? `Libera ${new Date(nextDate).toLocaleDateString('pt-BR')}`
//       : 'Esgotado';
//   } else {
//     label = `${available} livre${available > 1 ? 's' : ''}`;
//   }

//   return (
//     <span
//       className="d-inline-block px-2 py-1 rounded fw-semibold small"
//       style={{ backgroundColor: `${color}15`, color, border: `1px solid ${color}30` }}
//       title={
//         available === 0 && nextDate
//           ? `Esgotado — próxima vaga em ${new Date(nextDate).toLocaleDateString('pt-BR')}`
//           : undefined
//       }
//     >
//       {label}
//     </span>
//   );
// };

// // ── Numerador de ranking (substitui Badge pill) ──
// const RankNumber: React.FC<{ position: number; variant: 'top' | 'bottom' }> = ({ position, variant }) => {
//   const color = variant === 'top' ? COR_PRIMARIA : '#6c757d';
//   return (
//     <span
//       className="d-inline-flex align-items-center justify-content-center fw-bold"
//       style={{
//         width: 28,
//         height: 28,
//         borderRadius: '50%',
//         backgroundColor: `${color}15`,
//         color,
//         fontSize: 13,
//       }}
//     >
//       {position}
//     </span>
//   );
// };

// // ==========================================
// export default function RelatorioEquipamentos() {
//   const [report,            setReport]            = useState<ReportData | null>(null);
//   const [loading,           setLoading]           = useState<boolean>(true);
//   const [filters,           setFilters]           = useState<Filters>(EMPTY_FILTERS);
//   const [selectedEquipment, setSelectedEquipment] = useState<EquipmentRow | null>(null);

//   // 🆕 Aba ativa — controla a exibição dos KPIs/Filtros
//   const [activeTab, setActiveTab] = useState<string>('overview');

//   // 🆕 Estados do relatório de slots
//   const [slotsReport,  setSlotsReport]  = useState<SlotsReport | null>(null);
//   const [slotsLoading, setSlotsLoading] = useState<boolean>(false);

//   // 🆕 Fullscreen do mapa
//   const mapContainerRef = useRef<HTMLDivElement>(null);
//   const [isMapFullscreen, setIsMapFullscreen] = useState<boolean>(false);

//   const toggleMapFullscreen = () => {
//     const el = mapContainerRef.current;
//     if (!el) return;

//     if (!document.fullscreenElement) {
//       el.requestFullscreen?.().catch((err) => {
//         toast.error(`Erro ao abrir tela cheia: ${err.message}`);
//       });
//     } else {
//       document.exitFullscreen?.();
//     }
//   };

//   const fetchReport = async (activeFilters: Filters = filters) => {
//     try {
//       setLoading(true);
//       const params: Record<string, any> = {};
//       if (activeFilters.startDate) params.startDate = activeFilters.startDate;
//       if (activeFilters.endDate)   params.endDate   = activeFilters.endDate;
//       if (activeFilters.limit)     params.limit     = activeFilters.limit;
//       if (activeFilters.category)  params.category  = activeFilters.category;

//       const response = await api.get('/reports/equipments/sales', { params });
//       setReport(response.data);
//     } catch {
//       toast.error('Erro ao carregar relatório de equipamentos.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🆕 Busca relatório de slots (usa os mesmos filtros de data/categoria)
//   const fetchSlotsReport = async (activeFilters: Filters = filters) => {
//     try {
//       setSlotsLoading(true);
//       const params: Record<string, any> = {};
//       if (activeFilters.startDate) params.startDate = activeFilters.startDate;
//       if (activeFilters.endDate)   params.endDate   = activeFilters.endDate;
//       if (activeFilters.category)  params.category  = activeFilters.category;

//       const response = await api.get('/reports/equipments/available-slots', { params });
//       setSlotsReport(response.data);
//     } catch {
//       toast.error('Erro ao carregar relatório de disponibilidade.');
//     } finally {
//       setSlotsLoading(false);
//     }
//   };

//   useEffect(() => { fetchReport(EMPTY_FILTERS); }, []);

//   // 🆕 Sincroniza o estado quando o usuário sai do fullscreen com ESC
//   useEffect(() => {
//     const handleFsChange = () => setIsMapFullscreen(!!document.fullscreenElement);
//     document.addEventListener('fullscreenchange', handleFsChange);
//     return () => document.removeEventListener('fullscreenchange', handleFsChange);
//   }, []);

//   const handleFilterChange = (e: any) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: name === 'limit' ? Number(value) : value,
//     }));
//   };

//   const handleApply = () => {
//     fetchReport(filters);
//     // Atualiza slots somente se já tiverem sido carregados antes
//     if (slotsReport) fetchSlotsReport(filters);
//   };

//   const handleClear = () => {
//     setFilters(EMPTY_FILTERS);
//     fetchReport(EMPTY_FILTERS);
//     if (slotsReport) fetchSlotsReport(EMPTY_FILTERS);
//   };

//   // 🆕 Troca de aba — controla estado e carrega slots na primeira abertura
//   const handleTabSelect = (key: string | null) => {
//     if (!key) return;
//     setActiveTab(key);
//     if (key === 'slots' && !slotsReport) {
//       fetchSlotsReport(filters);
//     }
//   };

//   const summary      = report?.summary;
//   const slotsSummary = slotsReport?.summary;

//   // ── KPIs ──
//   const kpiItems = [
//     { label: 'Receita Total',     value: formatCurrency(summary?.totalRevenue ?? 0),           color: 'success' },
//     { label: 'Total de Pedidos',  value: formatNumber(summary?.totalOrders ?? 0),              color: 'primary' },
//     { label: 'Ticket Médio',      value: formatCurrency(summary?.avgTicket ?? 0),              color: 'info'    },
//     { label: 'Receita Média/Eq.', value: formatCurrency(summary?.avgRevenuePerEquipment ?? 0), color: 'warning' },
//   ];

//   const kpiItemsRow2 = [
//     { label: 'Equipamentos Ativos', value: formatNumber(summary?.equipmentsActive ?? 0),       color: 'success'   },
//     { label: 'Com Vendas',          value: formatNumber(summary?.equipmentsWithSales ?? 0),    color: 'primary'   },
//     { label: 'Sem Vendas',          value: formatNumber(summary?.equipmentsWithoutSales ?? 0), color: 'secondary' },
//     {
//       label: 'Taxa de Inadimplência',
//       value: formatPercent(summary?.defaultRate ?? 0),
//       color: (summary?.defaultRate ?? 0) > 10 ? 'danger' : 'warning',
//     },
//   ];

//   // ── Pizza de status financeiro (paleta do sistema) ──
//   const financialStatusData = summary ? [
//     { name: 'Pago',      value: summary.totalPaid,    color: COR_PRIMARIA },
//     { name: 'Pendente',  value: summary.totalPending, color: COR_ALERTA   },
//     { name: 'Em Atraso', value: summary.totalOverdue, color: COR_PERIGO   },
//   ].filter(d => d.value > 0) : [];

//   // 🆕 Equipamentos com coordenadas válidas (para o mapa)
//   const equipmentsWithCoords = (report?.allEquipments ?? []).filter(
//     eq => eq.latitude != null && eq.longitude != null
//   );

//   // 🆕 Flag de conveniência
//   const isOverview = activeTab === 'overview';

//   return (
//     <Container fluid className="p-4">

//       <PageHeader
//         title="Relatório de Equipamentos"
//         buttonLabel="Atualizar"
//         buttonIcon={FaSync}
//         onButtonClick={() => fetchReport(filters)}
//         subtitle={undefined}
//         children={undefined}
//       />

//       {/* 🆕 KPIs + Filtros aparecem SOMENTE na aba "Visão Geral" */}
//       {isOverview && (
//         <>
//           <Row className="mb-3">
//             <KpiCards items={kpiItems} colSize={3} />
//           </Row>
//           <Row className="mb-4">
//             <KpiCards items={kpiItemsRow2} colSize={3} />
//           </Row>

//           {/* ── Filtros ── */}
//           <Card className="mb-4 shadow-sm">
//             <Card.Body>
//               <Row className="g-3 align-items-end">
//                 <Col md={2}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Data Inicial</Form.Label>
//                     <Form.Control type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={2}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Data Final</Form.Label>
//                     <Form.Control type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
//                   </Form.Group>
//                 </Col>
//                 <Col md={3}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Categoria</Form.Label>
//                     <Form.Select name="category" value={filters.category} onChange={handleFilterChange}>
//                       <option value="">Todas as categorias</option>
//                       {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 <Col md={2}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">Top N</Form.Label>
//                     <Form.Select name="limit" value={filters.limit} onChange={handleFilterChange}>
//                       <option value={5}>Top 5</option>
//                       <option value={10}>Top 10</option>
//                       <option value={20}>Top 20</option>
//                       <option value={50}>Top 50</option>
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 <Col md={3} className="d-flex gap-2">
//                   <Button variant="primary" onClick={handleApply} disabled={loading}>
//                     {loading ? <Spinner size="sm" animation="border" /> : 'Aplicar'}
//                   </Button>
//                   <Button variant="outline-secondary" onClick={handleClear} disabled={loading}>
//                     Limpar
//                   </Button>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>
//         </>
//       )}

//       {/* ── Tabs (agora controladas pelo estado) ── */}
//       <Tabs
//         activeKey={activeTab}
//         onSelect={handleTabSelect}
//         className="mb-3"
//         mountOnEnter
//       >

//         {/* ─── ABA: Visão Geral ─── */}
//         <Tab eventKey="overview" title={<><FaChartLine className="me-2" />Visão Geral</>}>

//           <Card className="mb-4 shadow-sm">
//             <Card.Header className="bg-white fw-semibold">
//               <FaChartLine className="me-2" style={{ color: COR_PRIMARIA }} />
//               Evolução de Faturamento Mensal
//             </Card.Header>
//             <Card.Body>
//               {report && report.monthlyEvolution.length > 0 ? (
//                 <ResponsiveContainer width="100%" height={300}>
//                   <LineChart data={report.monthlyEvolution.map(m => ({ ...m, monthLabel: formatMonth(m.month) }))}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="monthLabel" />
//                     <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
//                     <Tooltip formatter={(v: number) => formatCurrency(v)} />
//                     <Legend />
//                     <Line type="monotone" dataKey="revenue" name="Receita" stroke={COR_PRIMARIA} strokeWidth={3} dot={{ r: 5 }} activeDot={{ r: 7 }} />
//                   </LineChart>
//                 </ResponsiveContainer>
//               ) : (
//                 <p className="text-center text-muted my-4">Sem dados para exibir.</p>
//               )}
//             </Card.Body>
//           </Card>

//           <Row className="g-3 mb-4">
//             <Col lg={7}>
//               <Card className="shadow-sm h-100">
//                 <Card.Header className="bg-white fw-semibold">
//                   <FaChartBar className="me-2" style={{ color: COR_SUCESSO }} />
//                   Faturamento por Categoria
//                 </Card.Header>
//                 <Card.Body>
//                   {report && report.byCategory.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={300}>
//                       <BarChart data={report.byCategory}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="category" />
//                         <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
//                         <Tooltip formatter={(v: number) => formatCurrency(v)} />
//                         <Bar dataKey="totalRevenue" name="Receita" radius={[8, 8, 0, 0]}>
//                           {report.byCategory.map((_, i) => (
//                             <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
//                           ))}
//                         </Bar>
//                       </BarChart>
//                     </ResponsiveContainer>
//                   ) : (
//                     <p className="text-center text-muted my-4">Sem dados para exibir.</p>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>

//             <Col lg={5}>
//               <Card className="shadow-sm h-100">
//                 <Card.Header className="bg-white fw-semibold">
//                   <FaMoneyBillWave className="me-2" style={{ color: COR_ALERTA }} />
//                   Status Financeiro
//                 </Card.Header>
//                 <Card.Body>
//                   {financialStatusData.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={300}>
//                       <PieChart>
//                         <Pie
//                           data={financialStatusData}
//                           dataKey="value"
//                           nameKey="name"
//                           cx="50%"
//                           cy="50%"
//                           outerRadius={100}
//                           label={({ name, percent }) => `${name} ${((percent ?? 0) * 100).toFixed(0)}%`}
//                         >
//                           {financialStatusData.map((entry, i) => (
//                             <Cell key={i} fill={entry.color} />
//                           ))}
//                         </Pie>
//                         <Tooltip formatter={(v: number) => formatCurrency(v)} />
//                       </PieChart>
//                     </ResponsiveContainer>
//                   ) : (
//                     <p className="text-center text-muted my-4">Sem dados financeiros.</p>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {report && report.byCategory.length > 0 && (
//             <Card className="shadow-sm mb-4">
//               <Card.Header className="bg-white fw-semibold">📊 Resumo por Categoria</Card.Header>
//               <Card.Body className="p-0">
//                 <DataTable
//                   columns={['Categoria', 'Equipamentos', 'Pedidos', 'Receita Total', '% do Total']}
//                   loading={false}
//                   emptyMessage=""
//                 >
//                   {report.byCategory.map(c => {
//                     const pct = summary && summary.totalRevenue > 0
//                       ? (c.totalRevenue / summary.totalRevenue) * 100
//                       : 0;
//                     return (
//                       <tr key={c.category}>
//                         <td className="fw-semibold">{c.category}</td>
//                         <td>{c.equipmentsCount}</td>
//                         <td>{c.totalOrders}</td>
//                         <td className="fw-semibold">{formatCurrency(c.totalRevenue)}</td>
//                         <td>
//                           <div className="d-flex align-items-center gap-2">
//                             <div className="progress flex-grow-1" style={{ height: 8 }}>
//                               <div
//                                 className="progress-bar"
//                                 style={{ width: `${pct}%`, backgroundColor: COR_PRIMARIA }}
//                               />
//                             </div>
//                             <small className="text-muted">{pct.toFixed(1)}%</small>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </DataTable>
//               </Card.Body>
//             </Card>
//           )}
//         </Tab>

//         {/* ─── ABA: Rankings ─── */}
//         <Tab eventKey="rankings" title={<><FaTrophy className="me-2" />Rankings</>}>
//           <Row className="g-3">
//             <Col lg={6}>
//               <RankingCard
//                 title="Mais Vendidos"
//                 icon={<FaTrophy />}
//                 color="success"
//                 rows={report?.topSelling ?? []}
//                 loading={loading}
//                 variant="top"
//                 onSelect={setSelectedEquipment}
//               />
//             </Col>
//             <Col lg={6}>
//               <RankingCard
//                 title="Menos Vendidos"
//                 icon={<FaArrowDown />}
//                 color="danger"
//                 rows={report?.leastSelling ?? []}
//                 loading={loading}
//                 variant="bottom"
//                 onSelect={setSelectedEquipment}
//               />
//             </Col>
//           </Row>
//         </Tab>

//         {/* ─── ABA: Tabela Detalhada ─── */}
//         <Tab eventKey="detailed" title={<><FaTv className="me-2" />Detalhado</>}>
//           <Card className="shadow-sm">
//             <Card.Header className="bg-white fw-semibold">
//               📋 Todos os Equipamentos ({report?.allEquipments.length ?? 0})
//             </Card.Header>
//             <Card.Body className="p-0">
//               <DataTable
//                 columns={['Equipamento', 'Categoria', 'Pedidos', 'Clientes', 'Receita', 'Ticket Médio', 'Inadimpl.', 'Ações']}
//                 loading={loading}
//                 emptyMessage="Nenhum equipamento encontrado."
//               >
//                 {(report?.allEquipments ?? []).map(eq => (
//                   <tr key={eq.equipmentId}>
//                     <td>
//                       <div className="fw-semibold">{eq.name}</div>
//                       <small className="text-muted">
//                         <code>{eq.identifierCode}</code> · 📍 {eq.location}
//                       </small>
//                     </td>
//                     <td><CategoryTag>{eq.category}</CategoryTag></td>
//                     <td className="text-center">{eq.ordersCount}</td>
//                     <td className="text-center">
//                       <FaUsers className="me-1 text-muted" />{eq.uniqueCustomers}
//                     </td>
//                     <td className="fw-semibold">{formatCurrency(eq.totalRevenue)}</td>
//                     <td>{formatCurrency(eq.avgTicket)}</td>
//                     <td>
//                       {eq.defaultRate > 0 ? (
//                         <DefaultRateTag rate={eq.defaultRate} />
//                       ) : (
//                         <span className="text-muted small">—</span>
//                       )}
//                     </td>
//                     <td>
//                       <Button size="sm" variant="outline-primary" onClick={() => setSelectedEquipment(eq)} disabled={eq.ordersCount === 0}>
//                         <FaEye />
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//               </DataTable>
//             </Card.Body>
//           </Card>
//         </Tab>

//         {/* ─── ABA: Inadimplência ─── */}
//         <Tab eventKey="overdue" title={<><FaExclamationTriangle className="me-2" />Inadimplência</>}>
//           <Card className="shadow-sm">
//             <Card.Header className="bg-white fw-semibold text-danger">
//               <FaExclamationTriangle className="me-2" />
//               Equipamentos com Inadimplência
//             </Card.Header>
//             <Card.Body className="p-0">
//               <DataTable
//                 columns={['Equipamento', 'Categoria', 'Receita Total', 'Em Atraso', 'Taxa Inadimpl.']}
//                 loading={loading}
//                 emptyMessage="🎉 Nenhuma inadimplência detectada!"
//               >
//                 {(report?.allEquipments ?? [])
//                   .filter(eq => eq.overdueRevenue > 0)
//                   .sort((a, b) => b.overdueRevenue - a.overdueRevenue)
//                   .map(eq => (
//                     <tr key={eq.equipmentId}>
//                       <td>
//                         <div className="fw-semibold">{eq.name}</div>
//                         <small className="text-muted"><code>{eq.identifierCode}</code></small>
//                       </td>
//                       <td><CategoryTag>{eq.category}</CategoryTag></td>
//                       <td>{formatCurrency(eq.totalRevenue)}</td>
//                       <td className="text-danger fw-bold">{formatCurrency(eq.overdueRevenue)}</td>
//                       <td><DefaultRateTag rate={eq.defaultRate} /></td>
//                     </tr>
//                   ))}
//               </DataTable>
//             </Card.Body>
//           </Card>
//         </Tab>

//         {/* ─── ABA: Disponibilidade (Slots) ─── */}
//         <Tab eventKey="slots" title={<><FaThLarge className="me-2" />Disponibilidade</>}>

//           {/* KPIs de slots */}
//           <Row className="g-3 mb-4">
//             <Col md={3}>
//               <Card className="bg-primary bg-opacity-10 border-0 text-center p-3">
//                 <small className="text-muted">Total de Slots</small>
//                 <h3 className="mb-0 text-primary">{formatNumber(slotsSummary?.totalSlots ?? 0)}</h3>
//               </Card>
//             </Col>
//             <Col md={3}>
//               <Card className="border-0 text-center p-3" style={{ backgroundColor: `${COR_SUCESSO}15` }}>
//                 <small className="text-muted">Disponíveis</small>
//                 <h3 className="mb-0" style={{ color: COR_SUCESSO }}>{formatNumber(slotsSummary?.totalAvailable ?? 0)}</h3>
//               </Card>
//             </Col>
//             <Col md={3}>
//               <Card className="bg-danger bg-opacity-10 border-0 text-center p-3">
//                 <small className="text-muted">Ocupados</small>
//                 <h3 className="mb-0 text-danger">{formatNumber(slotsSummary?.totalOccupied ?? 0)}</h3>
//               </Card>
//             </Col>
//             <Col md={3}>
//               <Card className="bg-warning bg-opacity-10 border-0 text-center p-3">
//                 <small className="text-muted">Taxa de Ocupação</small>
//                 <h3 className="mb-0 text-warning">{formatPercent(slotsSummary?.occupancyRate ?? 0)}</h3>
//               </Card>
//             </Col>
//           </Row>

//           <div className="alert alert-light border small mb-4">
//             💡 Considerando o período de{' '}
//             <strong>
//               {slotsReport?.period
//                 ? `${new Date(slotsReport.period.startDate).toLocaleDateString('pt-BR')} a ${new Date(slotsReport.period.endDate).toLocaleDateString('pt-BR')}`
//                 : 'próximos 30 dias'}
//             </strong>. Use os filtros de data na aba <strong>Visão Geral</strong> e clique em <strong>Aplicar</strong>.
//           </div>

//           {/* Loading inicial */}
//           {slotsLoading && !slotsReport ? (
//             <div className="text-center my-5">
//               <Spinner animation="border" variant="primary" />
//               <p className="text-muted mt-2">Carregando disponibilidade...</p>
//             </div>
//           ) : (
//             <>
//               {/* Gráfico de barras empilhadas por categoria */}
//               <Card className="mb-4 shadow-sm">
//                 <Card.Header className="bg-white fw-semibold">
//                   <FaThLarge className="me-2" style={{ color: COR_PRIMARIA }} />
//                   Disponibilidade por Categoria
//                 </Card.Header>
//                 <Card.Body>
//                   {slotsReport && slotsReport.byCategory.length > 0 ? (
//                     <ResponsiveContainer width="100%" height={300}>
//                       <BarChart data={slotsReport.byCategory}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="category" />
//                         <YAxis allowDecimals={false} />
//                         <Tooltip />
//                         <Legend />
//                         <Bar dataKey="availableSlots" name="Disponíveis" stackId="a" fill={COR_SUCESSO} />
//                         <Bar dataKey="occupiedSlots"  name="Ocupados"    stackId="a" fill={COR_PERIGO} radius={[8, 8, 0, 0]} />
//                       </BarChart>
//                     </ResponsiveContainer>
//                   ) : (
//                     <p className="text-center text-muted my-4">Sem dados para exibir.</p>
//                   )}
//                 </Card.Body>
//               </Card>

//               {/* Tabela detalhada de slots */}
//               <Card className="shadow-sm">
//                 <Card.Header className="bg-white fw-semibold">
//                   📋 Disponibilidade por Equipamento ({slotsReport?.equipments.length ?? 0})
//                 </Card.Header>
//                 <Card.Body className="p-0">
//                   <DataTable
//                     columns={['Equipamento', 'Categoria', 'Total Slots', 'Ocupados', 'Disponíveis', 'Ocupação']}
//                     loading={slotsLoading}
//                     emptyMessage="Nenhum equipamento encontrado."
//                   >
//                     {(slotsReport?.equipments ?? []).map(eq => (
//                       <tr key={eq.equipmentId}>
//                         <td>
//                           <div className="fw-semibold">{eq.name}</div>
//                           <small className="text-muted">
//                             <code>{eq.identifierCode}</code> · <FaMapMarkerAlt className="me-1" />{eq.location}
//                           </small>
//                         </td>
//                         <td><CategoryTag>{eq.category}</CategoryTag></td>
//                         <td className="text-center fw-semibold">{eq.totalSlots}</td>
//                         <td className="text-center text-danger">
//                           <FaLock className="me-1" />{eq.occupiedSlots}
//                         </td>
//                         <td className="text-center">
//                           {/* 🆕 agora passamos a data de liberação */}
//                           <AvailabilityTag available={eq.availableSlots} nextDate={eq.nextAvailableDate} />
//                         </td>
//                         <td style={{ minWidth: 140 }}>
//                           <div className="d-flex align-items-center gap-2">
//                             <div className="progress flex-grow-1" style={{ height: 8 }}>
//                               <div
//                                 className="progress-bar"
//                                 style={{
//                                   width: `${eq.occupancyRate}%`,
//                                   backgroundColor: eq.occupancyRate >= 100 ? COR_PERIGO : COR_PRIMARIA,
//                                 }}
//                               />
//                             </div>
//                             <small className="text-muted">{eq.occupancyRate.toFixed(0)}%</small>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </DataTable>
//                 </Card.Body>
//               </Card>
//             </>
//           )}
//         </Tab>

//         {/* ─── ABA: Mapa ─── 🆕 com botão de tela cheia */}
//         <Tab eventKey="map" title={<><FaMap className="me-2" />Mapa</>}>
//           <Card className="shadow-sm">
//             <Card.Header className="bg-white fw-semibold d-flex justify-content-between align-items-center">
//               <span>
//                 <FaMapMarkerAlt className="me-2" style={{ color: COR_PRIMARIA }} />
//                 Localização dos Equipamentos ({equipmentsWithCoords.length})
//               </span>

//               {/* 🆕 Botão de tela cheia */}
//               <Button
//                 size="sm"
//                 variant="outline-primary"
//                 onClick={toggleMapFullscreen}
//                 disabled={equipmentsWithCoords.length === 0}
//                 title={isMapFullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
//               >
//                 {isMapFullscreen ? <FaCompress className="me-1" /> : <FaExpand className="me-1" />}
//                 {isMapFullscreen ? 'Sair' : 'Tela cheia'}
//               </Button>
//             </Card.Header>

//             <Card.Body>
//               {loading ? (
//                 <div className="text-center my-5">
//                   <Spinner animation="border" variant="primary" />
//                   <p className="text-muted mt-2">Carregando mapa...</p>
//                 </div>
//               ) : equipmentsWithCoords.length > 0 ? (
//                 // 🆕 Container que entra em fullscreen
//                 <div
//                   ref={mapContainerRef}
//                   style={{
//                     width: '100%',
//                     height: isMapFullscreen ? '100%' : 500,
//                     background: '#fff',
//                   }}
//                 >
//                   <EquipmentMap equipments={equipmentsWithCoords} />
//                 </div>
//               ) : (
//                 <p className="text-center text-muted my-4">
//                   📍 Nenhum equipamento com coordenadas cadastradas.
//                 </p>
//               )}
//             </Card.Body>
//           </Card>
//         </Tab>

//       </Tabs>

//       <EquipmentDetailModal
//         equipment={selectedEquipment}
//         onClose={() => setSelectedEquipment(null)}
//       />
//     </Container>
//   );
// }

// // ==========================================
// // CARD DE RANKING
// // ==========================================
// interface RankingCardProps {
//   title:    string;
//   icon:     React.ReactNode;
//   color:    string;
//   rows:     EquipmentRow[];
//   loading:  boolean;
//   variant:  'top' | 'bottom';
//   onSelect: (eq: EquipmentRow) => void;
// }

// function RankingCard({ title, icon, color, rows, loading, variant, onSelect }: RankingCardProps) {
//   return (
//     <Card className="border-0 shadow-sm h-100">
//       <Card.Header className={`bg-${color} bg-opacity-10 text-${color} fw-semibold d-flex align-items-center gap-2`}>
//         {icon} {title}
//       </Card.Header>
//       <Card.Body className="p-0">
//         <DataTable
//           columns={['#', 'Equipamento', 'Pedidos', 'Receita', 'Ações']}
//           loading={loading}
//           emptyMessage="Nenhum equipamento encontrado."
//         >
//           {rows.length > 0 && rows.map((row, idx) => (
//             <tr key={row.equipmentId}>
//               <td className="text-center">
//                 <RankNumber position={idx + 1} variant={variant} />
//               </td>
//               <td>
//                 <div className="fw-semibold d-flex align-items-center gap-2">
//                   <FaTv className="text-muted" />
//                   {row.name}
//                 </div>
//                 <small className="text-muted">
//                   <code>{row.identifierCode}</code> · {row.category}
//                 </small>
//               </td>
//               <td className="text-center">
//                 <span className="fw-bold" style={{ color: row.ordersCount === 0 ? COR_PERIGO : undefined }}>
//                   {row.ordersCount}
//                 </span>
//               </td>
//               <td className="fw-semibold">{formatCurrency(row.totalRevenue)}</td>
//               <td>
//                 <Button size="sm" variant="outline-primary" onClick={() => onSelect(row)} disabled={row.ordersCount === 0}>
//                   <FaEye />
//                 </Button>
//               </td>
//             </tr>
//           ))}
//         </DataTable>
//       </Card.Body>
//     </Card>
//   );
// }

// // ==========================================
// // MODAL DE DETALHE
// // ==========================================
// interface DetailModalProps {
//   equipment: EquipmentRow | null;
//   onClose:   () => void;
// }

// function EquipmentDetailModal({ equipment, onClose }: DetailModalProps) {
//   if (!equipment) return null;

//   const monthlyData = equipment.monthlyRevenue.map(m => ({
//     ...m,
//     monthLabel: formatMonth(m.month),
//   }));

//   return (
//     <Modal show={!!equipment} onHide={onClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title className="d-flex align-items-center gap-2">
//           <FaTv />
//           {equipment.name}
//           <CategoryTag>{equipment.category}</CategoryTag>
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Row className="mb-3 g-2">
//           <Col md={3}>
//             <Card className="bg-primary bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Pedidos</small>
//               <h4 className="mb-0 text-primary">{equipment.ordersCount}</h4>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="bg-success bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Receita</small>
//               <h6 className="mb-0 text-success">{formatCurrency(equipment.totalRevenue)}</h6>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="bg-info bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Ticket Médio</small>
//               <h6 className="mb-0 text-info">{formatCurrency(equipment.avgTicket)}</h6>
//             </Card>
//           </Col>
//           <Col md={3}>
//             <Card className="bg-warning bg-opacity-10 border-0 text-center p-2">
//               <small className="text-muted">Clientes</small>
//               <h4 className="mb-0 text-warning">{equipment.uniqueCustomers}</h4>
//             </Card>
//           </Col>
//         </Row>

//         <h6 className="text-muted mb-3">
//           <FaChartBar className="me-2" />
//           Faturamento por Mês
//         </h6>
//         {monthlyData.length > 0 ? (
//           <ResponsiveContainer width="100%" height={250}>
//             <BarChart data={monthlyData}>
//               <CartesianGrid strokeDasharray="3 3" />
//               <XAxis dataKey="monthLabel" />
//               <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
//               <Tooltip formatter={(v: number) => formatCurrency(v)} />
//               <Bar dataKey="revenue" name="Receita" fill={COR_PRIMARIA} radius={[8, 8, 0, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         ) : (
//           <p className="text-center text-muted my-3">Sem histórico mensal.</p>
//         )}

//         <hr />
//         <Row className="small">
//           <Col md={6}>
//             <strong>📍 Localização:</strong> {equipment.location}<br />
//             <strong>🔢 Código:</strong> <code>{equipment.identifierCode}</code><br />
//             <strong>🎯 Slots:</strong> {equipment.slots}
//           </Col>
//           <Col md={6}>
//             <strong>💰 Pago:</strong> <span className="text-success">{formatCurrency(equipment.paidRevenue)}</span><br />
//             <strong>⏳ Pendente:</strong> <span className="text-warning">{formatCurrency(equipment.pendingRevenue)}</span><br />
//             <strong>⚠️ Em atraso:</strong> <span className="text-danger">{formatCurrency(equipment.overdueRevenue)}</span>
//           </Col>
//         </Row>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onClose}>Fechar</Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

//1406 - 2
// src/pages/Relatorios/RelatorioEquipamentos.tsx

import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, Modal, Tabs, Tab } from 'react-bootstrap';
import {
  FaTrophy, FaArrowDown, FaTv, FaSync, FaChartLine, FaChartBar,
  FaExclamationTriangle, FaEye, FaUsers, FaMoneyBillWave,
  FaThLarge, FaLock, FaMapMarkerAlt, FaMap, FaExpand, FaCompress,
} from 'react-icons/fa';
import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell,
} from 'recharts';
import { toast } from 'react-toastify';
import api from '../../services/api';

import { EquipmentMap } from '../../components/shared/EquipmentMap';

import { PageHeader } from '../../components/shared/PageHeader';
import { KpiCards }   from '../../components/shared/KpiCard';
import { DataTable }  from '../../components/shared/DataTable';

// ── Categorias (mesmas do cadastro de equipamentos) ──
const CATEGORIAS = ['Outdoor LED', 'Outdoor Lona', 'Busdoor', 'Indoor', 'Frontlight'];

// 🎨 Paleta oficial do sistema (mesma do Dashboard)
const CHART_COLORS = ['#4361ee', '#3f37c9', '#7209b7', '#f72585', '#4cc9f0', '#f8961e', '#6c757d'];
const COR_PRIMARIA = '#4361ee';
const COR_SUCESSO  = '#4cc9f0';
const COR_ALERTA   = '#f8961e';
const COR_PERIGO   = '#f72585';

// 🆕 Limite alto para garantir que o backend devolva TODOS os equipamentos.
// O "Top N" passa a ser aplicado no front, apenas nos rankings.
const FULL_LIMIT = 1000;

// ── Tipos ──
interface Filters {
  startDate: string;
  endDate:   string;
  limit:     number;
  category:  string;
}

interface MonthlyPoint {
  month:   string;
  revenue: number;
}

interface EquipmentRow {
  equipmentId:     string;
  name:            string;
  identifierCode:  string;
  category:        string;
  location:        string;
  slots:           number;
  isActive:        boolean;
  ordersCount:     number;
  totalRevenue:    number;
  totalDaysRented: number;
  paidRevenue:     number;
  pendingRevenue:  number;
  overdueRevenue:  number;
  uniqueCustomers: number;
  avgTicket:       number;
  defaultRate:     number;
  monthlyRevenue:  MonthlyPoint[];
  latitude:  number | null;
  longitude: number | null;
}

interface CategoryRow {
  category:        string;
  equipmentsCount: number;
  totalRevenue:    number;
  totalOrders:     number;
}

interface ReportData {
  period: { startDate: string | null; endDate: string | null };
  summary: {
    totalEquipments:        number;
    equipmentsActive:       number;
    equipmentsWithSales:    number;
    equipmentsWithoutSales: number;
    totalOrders:            number;
    totalRevenue:           number;
    totalPaid:              number;
    totalPending:           number;
    totalOverdue:           number;
    avgTicket:              number;
    avgRevenuePerEquipment: number;
    defaultRate:            number;
  };
  topSelling:       EquipmentRow[];
  leastSelling:     EquipmentRow[];
  byCategory:       CategoryRow[];
  monthlyEvolution: MonthlyPoint[];
  allEquipments:    EquipmentRow[];
}

// ── Tipos de Slots ──
interface SlotRow {
  equipmentId:    string;
  name:           string;
  identifierCode: string;
  category:       string;
  location:       string;
  totalSlots:     number;
  occupiedSlots:  number;
  availableSlots: number;
  occupancyRate:  number;
  nextAvailableDate: string | null; // 🆕 quando libera (se esgotado)
}

interface CategorySlot {
  category:       string;
  totalSlots:     number;
  occupiedSlots:  number;
  availableSlots: number;
  occupancyRate:  number;
}

interface SlotsReport {
  period: { startDate: string; endDate: string };
  summary: {
    totalEquipments: number;
    totalSlots:      number;
    totalOccupied:   number;
    totalAvailable:  number;
    occupancyRate:   number;
  };
  byCategory: CategorySlot[];
  equipments: SlotRow[];
}

const EMPTY_FILTERS: Filters = { startDate: '', endDate: '', limit: 10, category: '' };

// ── Helpers ──
const formatCurrency = (v: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

const formatNumber  = (v: number) => (v ?? 0).toLocaleString('pt-BR');
const formatPercent = (v: number) => `${(v ?? 0).toFixed(1)}%`;
const formatMonth   = (m: string) => {
  const [y, mo] = m.split('-');
  return `${mo}/${y.slice(2)}`;
};

// ── Tag de categoria (substitui Badge) ──
const CategoryTag: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span
    className="d-inline-block px-2 py-1 rounded-pill small fw-medium"
    style={{
      backgroundColor: '#f1f3f5',
      color: '#495057',
      border: '1px solid #e9ecef',
    }}
  >
    {children}
  </span>
);

// ── Tag de inadimplência (substitui Badge colorido) ──
const DefaultRateTag: React.FC<{ rate: number }> = ({ rate }) => {
  const isHigh = rate > 20;
  const color  = isHigh ? COR_PERIGO : COR_ALERTA;

  return (
    <span
      className="d-inline-block px-2 py-1 rounded small fw-semibold"
      style={{
        backgroundColor: `${color}15`,
        color,
        border: `1px solid ${color}30`,
      }}
    >
      {formatPercent(rate)}
    </span>
  );
};

// ── Tag de disponibilidade de slots ── 🆕 agora mostra a data de liberação
const AvailabilityTag: React.FC<{ available: number; nextDate?: string | null }> = ({
  available,
  nextDate,
}) => {
  const color = available === 0 ? COR_PERIGO : available <= 2 ? COR_ALERTA : COR_SUCESSO;

  let label: string;
  if (available === 0) {
    label = nextDate
      ? `Libera ${new Date(nextDate).toLocaleDateString('pt-BR')}`
      : 'Esgotado';
  } else {
    label = `${available} livre${available > 1 ? 's' : ''}`;
  }

  return (
    <span
      className="d-inline-block px-2 py-1 rounded fw-semibold small"
      style={{ backgroundColor: `${color}15`, color, border: `1px solid ${color}30` }}
      title={
        available === 0 && nextDate
          ? `Esgotado — próxima vaga em ${new Date(nextDate).toLocaleDateString('pt-BR')}`
          : undefined
      }
    >
      {label}
    </span>
  );
};

// ── Numerador de ranking (substitui Badge pill) ──
const RankNumber: React.FC<{ position: number; variant: 'top' | 'bottom' }> = ({ position, variant }) => {
  const color = variant === 'top' ? COR_PRIMARIA : '#6c757d';
  return (
    <span
      className="d-inline-flex align-items-center justify-content-center fw-bold"
      style={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: `${color}15`,
        color,
        fontSize: 13,
      }}
    >
      {position}
    </span>
  );
};

// ==========================================
export default function RelatorioEquipamentos() {
  const [report,            setReport]            = useState<ReportData | null>(null);
  const [loading,           setLoading]           = useState<boolean>(true);
  const [filters,           setFilters]           = useState<Filters>(EMPTY_FILTERS);
  const [selectedEquipment, setSelectedEquipment] = useState<EquipmentRow | null>(null);

  // 🆕 Aba ativa — controla a exibição dos KPIs/Top N
  const [activeTab, setActiveTab] = useState<string>('overview');

  // 🆕 Estados do relatório de slots
  const [slotsReport,  setSlotsReport]  = useState<SlotsReport | null>(null);
  const [slotsLoading, setSlotsLoading] = useState<boolean>(false);

  // 🆕 Fullscreen do mapa
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const [isMapFullscreen, setIsMapFullscreen] = useState<boolean>(false);

  const toggleMapFullscreen = () => {
    const el = mapContainerRef.current;
    if (!el) return;

    if (!document.fullscreenElement) {
      el.requestFullscreen?.().catch((err) => {
        toast.error(`Erro ao abrir tela cheia: ${err.message}`);
      });
    } else {
      document.exitFullscreen?.();
    }
  };

  const fetchReport = async (activeFilters: Filters = filters) => {
    try {
      setLoading(true);
      const params: Record<string, any> = {};
      if (activeFilters.startDate) params.startDate = activeFilters.startDate;
      if (activeFilters.endDate)   params.endDate   = activeFilters.endDate;
      if (activeFilters.category)  params.category  = activeFilters.category;

      // ⚠️ Sempre buscamos TODOS os equipamentos (limit alto).
      // O "Top N" é aplicado no front, apenas nos rankings — assim
      // Detalhado e Inadimplência nunca perdem registros.
      params.limit = FULL_LIMIT;

      const response = await api.get('/reports/equipments/sales', { params });
      setReport(response.data);
    } catch {
      toast.error('Erro ao carregar relatório de equipamentos.');
    } finally {
      setLoading(false);
    }
  };

  // 🆕 Busca relatório de slots (usa os mesmos filtros de data/categoria)
  const fetchSlotsReport = async (activeFilters: Filters = filters) => {
    try {
      setSlotsLoading(true);
      const params: Record<string, any> = {};
      if (activeFilters.startDate) params.startDate = activeFilters.startDate;
      if (activeFilters.endDate)   params.endDate   = activeFilters.endDate;
      if (activeFilters.category)  params.category  = activeFilters.category;

      const response = await api.get('/reports/equipments/available-slots', { params });
      setSlotsReport(response.data);
    } catch {
      toast.error('Erro ao carregar relatório de disponibilidade.');
    } finally {
      setSlotsLoading(false);
    }
  };

  useEffect(() => { fetchReport(EMPTY_FILTERS); }, []);

  // 🆕 Sincroniza o estado quando o usuário sai do fullscreen com ESC
  useEffect(() => {
    const handleFsChange = () => setIsMapFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', handleFsChange);
    return () => document.removeEventListener('fullscreenchange', handleFsChange);
  }, []);

  const handleFilterChange = (e: any) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: name === 'limit' ? Number(value) : value,
    }));
  };

  // 🆕 Aplica filtros — recarrega slots se estiver na aba de slots OU já carregou antes
  const handleApply = () => {
    fetchReport(filters);
    if (activeTab === 'slots' || slotsReport) {
      fetchSlotsReport(filters);
    }
  };

  const handleClear = () => {
    setFilters(EMPTY_FILTERS);
    fetchReport(EMPTY_FILTERS);
    if (activeTab === 'slots' || slotsReport) {
      fetchSlotsReport(EMPTY_FILTERS);
    }
  };

  // 🆕 Troca de aba — controla estado e carrega slots na primeira abertura
  const handleTabSelect = (key: string | null) => {
    if (!key) return;
    setActiveTab(key);
    if (key === 'slots' && !slotsReport) {
      fetchSlotsReport(filters);
    }
  };

  const summary      = report?.summary;
  const slotsSummary = slotsReport?.summary;

  // ── KPIs ──
  const kpiItems = [
    { label: 'Receita Total',     value: formatCurrency(summary?.totalRevenue ?? 0),           color: 'success' },
    { label: 'Total de Pedidos',  value: formatNumber(summary?.totalOrders ?? 0),              color: 'primary' },
    { label: 'Ticket Médio',      value: formatCurrency(summary?.avgTicket ?? 0),              color: 'info'    },
    { label: 'Receita Média/Eq.', value: formatCurrency(summary?.avgRevenuePerEquipment ?? 0), color: 'warning' },
  ];

  const kpiItemsRow2 = [
    { label: 'Equipamentos Ativos', value: formatNumber(summary?.equipmentsActive ?? 0),       color: 'success'   },
    { label: 'Com Vendas',          value: formatNumber(summary?.equipmentsWithSales ?? 0),    color: 'primary'   },
    { label: 'Sem Vendas',          value: formatNumber(summary?.equipmentsWithoutSales ?? 0), color: 'secondary' },
    {
      label: 'Taxa de Inadimplência',
      value: formatPercent(summary?.defaultRate ?? 0),
      color: (summary?.defaultRate ?? 0) > 10 ? 'danger' : 'warning',
    },
  ];

  // ── Pizza de status financeiro (paleta do sistema) ──
  const financialStatusData = summary ? [
    { name: 'Pago',      value: summary.totalPaid,    color: COR_PRIMARIA },
    { name: 'Pendente',  value: summary.totalPending, color: COR_ALERTA   },
    { name: 'Em Atraso', value: summary.totalOverdue, color: COR_PERIGO   },
  ].filter(d => d.value > 0) : [];

  // 🆕 Equipamentos com coordenadas válidas (para o mapa)
  const equipmentsWithCoords = (report?.allEquipments ?? []).filter(
    eq => eq.latitude != null && eq.longitude != null
  );

  // 🆕 Rankings com Top N aplicado no front
  const topSellingRows   = (report?.topSelling   ?? []).slice(0, filters.limit);
  const leastSellingRows = (report?.leastSelling ?? []).slice(0, filters.limit);

  // 🆕 Flags de conveniência
  const isOverview = activeTab === 'overview';
  const busy       = loading || slotsLoading;

  return (
    <Container fluid className="p-4">

      <PageHeader
        title="Relatório de Equipamentos"
        buttonLabel="Atualizar"
        buttonIcon={FaSync}
        onButtonClick={() => fetchReport(filters)}
        subtitle={undefined}
        children={undefined}
      />

      {/* 🆕 KPIs aparecem SOMENTE na aba "Visão Geral" */}
      {isOverview && (
        <>
          <Row className="mb-3">
            <KpiCards items={kpiItems} colSize={3} />
          </Row>
          <Row className="mb-4">
            <KpiCards items={kpiItemsRow2} colSize={3} />
          </Row>
        </>
      )}

      {/* 🆕 Filtros aparecem em TODAS as abas (alimentam todos os relatórios) */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Row className="g-3 align-items-end">
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small fw-semibold">Data Inicial</Form.Label>
                <Form.Control type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small fw-semibold">Data Final</Form.Label>
                <Form.Control type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small fw-semibold">Categoria</Form.Label>
                <Form.Select name="category" value={filters.category} onChange={handleFilterChange}>
                  <option value="">Todas as categorias</option>
                  {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* 🆕 "Top N" só faz sentido na Visão Geral / Rankings */}
            {isOverview && (
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small fw-semibold">Top N</Form.Label>
                  <Form.Select name="limit" value={filters.limit} onChange={handleFilterChange}>
                    <option value={5}>Top 5</option>
                    <option value={10}>Top 10</option>
                    <option value={20}>Top 20</option>
                    <option value={50}>Top 50</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            <Col md={3} className="d-flex gap-2">
              <Button variant="primary" onClick={handleApply} disabled={busy}>
                {busy ? <Spinner size="sm" animation="border" /> : 'Aplicar'}
              </Button>
              <Button variant="outline-secondary" onClick={handleClear} disabled={busy}>
                Limpar
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ── Tabs (controladas pelo estado) ── */}
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        className="mb-3"
        mountOnEnter
      >

        {/* ─── ABA: Visão Geral ─── */}
        <Tab eventKey="overview" title={<><FaChartLine className="me-2" />Visão Geral</>}>

          <Card className="mb-4 shadow-sm">
            <Card.Header className="bg-white fw-semibold">
              <FaChartLine className="me-2" style={{ color: COR_PRIMARIA }} />
              Evolução de Faturamento Mensal
            </Card.Header>
            <Card.Body>
              {report && report.monthlyEvolution.length > 0 ? (
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={report.monthlyEvolution.map(m => ({ ...m, monthLabel: formatMonth(m.month) }))}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="monthLabel" />
                    <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
                    <Tooltip formatter={(v: number) => formatCurrency(v)} />
                    <Legend />
                    <Line type="monotone" dataKey="revenue" name="Receita" stroke={COR_PRIMARIA} strokeWidth={3} dot={{ r: 5 }} activeDot={{ r: 7 }} />
                  </LineChart>
                </ResponsiveContainer>
              ) : (
                <p className="text-center text-muted my-4">Sem dados para exibir.</p>
              )}
            </Card.Body>
          </Card>

          <Row className="g-3 mb-4">
            <Col lg={7}>
              <Card className="shadow-sm h-100">
                <Card.Header className="bg-white fw-semibold">
                  <FaChartBar className="me-2" style={{ color: COR_SUCESSO }} />
                  Faturamento por Categoria
                </Card.Header>
                <Card.Body>
                  {report && report.byCategory.length > 0 ? (
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={report.byCategory}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="category" />
                        <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
                        <Tooltip formatter={(v: number) => formatCurrency(v)} />
                        <Bar dataKey="totalRevenue" name="Receita" radius={[8, 8, 0, 0]}>
                          {report.byCategory.map((_, i) => (
                            <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                          ))}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  ) : (
                    <p className="text-center text-muted my-4">Sem dados para exibir.</p>
                  )}
                </Card.Body>
              </Card>
            </Col>

            <Col lg={5}>
              <Card className="shadow-sm h-100">
                <Card.Header className="bg-white fw-semibold">
                  <FaMoneyBillWave className="me-2" style={{ color: COR_ALERTA }} />
                  Status Financeiro
                </Card.Header>
                <Card.Body>
                  {financialStatusData.length > 0 ? (
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={financialStatusData}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          outerRadius={100}
                          label={({ name, percent }) => `${name} ${((percent ?? 0) * 100).toFixed(0)}%`}
                        >
                          {financialStatusData.map((entry, i) => (
                            <Cell key={i} fill={entry.color} />
                          ))}
                        </Pie>
                        <Tooltip formatter={(v: number) => formatCurrency(v)} />
                      </PieChart>
                    </ResponsiveContainer>
                  ) : (
                    <p className="text-center text-muted my-4">Sem dados financeiros.</p>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {report && report.byCategory.length > 0 && (
            <Card className="shadow-sm mb-4">
              <Card.Header className="bg-white fw-semibold">📊 Resumo por Categoria</Card.Header>
              <Card.Body className="p-0">
                <DataTable
                  columns={['Categoria', 'Equipamentos', 'Pedidos', 'Receita Total', '% do Total']}
                  loading={false}
                  emptyMessage=""
                >
                  {report.byCategory.map(c => {
                    const pct = summary && summary.totalRevenue > 0
                      ? (c.totalRevenue / summary.totalRevenue) * 100
                      : 0;
                    return (
                      <tr key={c.category}>
                        <td className="fw-semibold">{c.category}</td>
                        <td>{c.equipmentsCount}</td>
                        <td>{c.totalOrders}</td>
                        <td className="fw-semibold">{formatCurrency(c.totalRevenue)}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <div className="progress flex-grow-1" style={{ height: 8 }}>
                              <div
                                className="progress-bar"
                                style={{ width: `${pct}%`, backgroundColor: COR_PRIMARIA }}
                              />
                            </div>
                            <small className="text-muted">{pct.toFixed(1)}%</small>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              </Card.Body>
            </Card>
          )}
        </Tab>

        {/* ─── ABA: Rankings ─── */}
        <Tab eventKey="rankings" title={<><FaTrophy className="me-2" />Rankings</>}>
          <Row className="g-3">
            <Col lg={6}>
              <RankingCard
                title="Mais Vendidos"
                icon={<FaTrophy />}
                color="success"
                rows={topSellingRows}
                loading={loading}
                variant="top"
                onSelect={setSelectedEquipment}
              />
            </Col>
            <Col lg={6}>
              <RankingCard
                title="Menos Vendidos"
                icon={<FaArrowDown />}
                color="danger"
                rows={leastSellingRows}
                loading={loading}
                variant="bottom"
                onSelect={setSelectedEquipment}
              />
            </Col>
          </Row>
        </Tab>

        {/* ─── ABA: Tabela Detalhada ─── */}
        <Tab eventKey="detailed" title={<><FaTv className="me-2" />Detalhado</>}>
          <Card className="shadow-sm">
            <Card.Header className="bg-white fw-semibold">
              📋 Todos os Equipamentos ({report?.allEquipments.length ?? 0})
            </Card.Header>
            <Card.Body className="p-0">
              <DataTable
                columns={['Equipamento', 'Categoria', 'Pedidos', 'Clientes', 'Receita', 'Ticket Médio', 'Inadimpl.', 'Ações']}
                loading={loading}
                emptyMessage="Nenhum equipamento encontrado."
              >
                {(report?.allEquipments ?? []).map(eq => (
                  <tr key={eq.equipmentId}>
                    <td>
                      <div className="fw-semibold">{eq.name}</div>
                      <small className="text-muted">
                        <code>{eq.identifierCode}</code> · 📍 {eq.location}
                      </small>
                    </td>
                    <td><CategoryTag>{eq.category}</CategoryTag></td>
                    <td className="text-center">{eq.ordersCount}</td>
                    <td className="text-center">
                      <FaUsers className="me-1 text-muted" />{eq.uniqueCustomers}
                    </td>
                    <td className="fw-semibold">{formatCurrency(eq.totalRevenue)}</td>
                    <td>{formatCurrency(eq.avgTicket)}</td>
                    <td>
                      {eq.defaultRate > 0 ? (
                        <DefaultRateTag rate={eq.defaultRate} />
                      ) : (
                        <span className="text-muted small">—</span>
                      )}
                    </td>
                    <td>
                      <Button size="sm" variant="outline-primary" onClick={() => setSelectedEquipment(eq)} disabled={eq.ordersCount === 0}>
                        <FaEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </DataTable>
            </Card.Body>
          </Card>
        </Tab>

        {/* ─── ABA: Inadimplência ─── */}
        <Tab eventKey="overdue" title={<><FaExclamationTriangle className="me-2" />Inadimplência</>}>
          <Card className="shadow-sm">
            <Card.Header className="bg-white fw-semibold text-danger">
              <FaExclamationTriangle className="me-2" />
              Equipamentos com Inadimplência
            </Card.Header>
            <Card.Body className="p-0">
              <DataTable
                columns={['Equipamento', 'Categoria', 'Receita Total', 'Em Atraso', 'Taxa Inadimpl.']}
                loading={loading}
                emptyMessage="🎉 Nenhuma inadimplência detectada!"
              >
                {(report?.allEquipments ?? [])
                  .filter(eq => eq.overdueRevenue > 0)
                  .sort((a, b) => b.overdueRevenue - a.overdueRevenue)
                  .map(eq => (
                    <tr key={eq.equipmentId}>
                      <td>
                        <div className="fw-semibold">{eq.name}</div>
                        <small className="text-muted"><code>{eq.identifierCode}</code></small>
                      </td>
                      <td><CategoryTag>{eq.category}</CategoryTag></td>
                      <td>{formatCurrency(eq.totalRevenue)}</td>
                      <td className="text-danger fw-bold">{formatCurrency(eq.overdueRevenue)}</td>
                      <td><DefaultRateTag rate={eq.defaultRate} /></td>
                    </tr>
                  ))}
              </DataTable>
            </Card.Body>
          </Card>
        </Tab>

        {/* ─── ABA: Disponibilidade (Slots) ─── */}
        <Tab eventKey="slots" title={<><FaThLarge className="me-2" />Disponibilidade</>}>

          {/* KPIs de slots */}
          <Row className="g-3 mb-4">
            <Col md={3}>
              <Card className="bg-primary bg-opacity-10 border-0 text-center p-3">
                <small className="text-muted">Total de Slots</small>
                <h3 className="mb-0 text-primary">{formatNumber(slotsSummary?.totalSlots ?? 0)}</h3>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 text-center p-3" style={{ backgroundColor: `${COR_SUCESSO}15` }}>
                <small className="text-muted">Disponíveis</small>
                <h3 className="mb-0" style={{ color: COR_SUCESSO }}>{formatNumber(slotsSummary?.totalAvailable ?? 0)}</h3>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="bg-danger bg-opacity-10 border-0 text-center p-3">
                <small className="text-muted">Ocupados</small>
                <h3 className="mb-0 text-danger">{formatNumber(slotsSummary?.totalOccupied ?? 0)}</h3>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="bg-warning bg-opacity-10 border-0 text-center p-3">
                <small className="text-muted">Taxa de Ocupação</small>
                <h3 className="mb-0 text-warning">{formatPercent(slotsSummary?.occupancyRate ?? 0)}</h3>
              </Card>
            </Col>
          </Row>

          {/* 🆕 aviso simplificado — filtros agora estão sempre visíveis acima */}
          <div className="alert alert-light border small mb-4">
            💡 Considerando o período de{' '}
            <strong>
              {slotsReport?.period
                ? `${new Date(slotsReport.period.startDate).toLocaleDateString('pt-BR')} a ${new Date(slotsReport.period.endDate).toLocaleDateString('pt-BR')}`
                : 'próximos 30 dias'}
            </strong>. Ajuste as datas acima e clique em <strong>Aplicar</strong>.
          </div>

          {/* Loading inicial */}
          {slotsLoading && !slotsReport ? (
            <div className="text-center my-5">
              <Spinner animation="border" variant="primary" />
              <p className="text-muted mt-2">Carregando disponibilidade...</p>
            </div>
          ) : (
            <>
              {/* Gráfico de barras empilhadas por categoria */}
              <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-white fw-semibold">
                  <FaThLarge className="me-2" style={{ color: COR_PRIMARIA }} />
                  Disponibilidade por Categoria
                </Card.Header>
                <Card.Body>
                  {slotsReport && slotsReport.byCategory.length > 0 ? (
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={slotsReport.byCategory}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="category" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="availableSlots" name="Disponíveis" stackId="a" fill={COR_SUCESSO} />
                        <Bar dataKey="occupiedSlots"  name="Ocupados"    stackId="a" fill={COR_PERIGO} radius={[8, 8, 0, 0]} />
                      </BarChart>
                    </ResponsiveContainer>
                  ) : (
                    <p className="text-center text-muted my-4">Sem dados para exibir.</p>
                  )}
                </Card.Body>
              </Card>

              {/* Tabela detalhada de slots */}
              <Card className="shadow-sm">
                <Card.Header className="bg-white fw-semibold">
                  📋 Disponibilidade por Equipamento ({slotsReport?.equipments.length ?? 0})
                </Card.Header>
                <Card.Body className="p-0">
                  <DataTable
                    columns={['Equipamento', 'Categoria', 'Total Slots', 'Ocupados', 'Disponíveis', 'Ocupação']}
                    loading={slotsLoading}
                    emptyMessage="Nenhum equipamento encontrado."
                  >
                    {(slotsReport?.equipments ?? []).map(eq => (
                      <tr key={eq.equipmentId}>
                        <td>
                          <div className="fw-semibold">{eq.name}</div>
                          <small className="text-muted">
                            <code>{eq.identifierCode}</code> · <FaMapMarkerAlt className="me-1" />{eq.location}
                          </small>
                        </td>
                        <td><CategoryTag>{eq.category}</CategoryTag></td>
                        <td className="text-center fw-semibold">{eq.totalSlots}</td>
                        <td className="text-center text-danger">
                          <FaLock className="me-1" />{eq.occupiedSlots}
                        </td>
                        <td className="text-center">
                          <AvailabilityTag available={eq.availableSlots} nextDate={eq.nextAvailableDate} />
                        </td>
                        <td style={{ minWidth: 140 }}>
                          <div className="d-flex align-items-center gap-2">
                            <div className="progress flex-grow-1" style={{ height: 8 }}>
                              <div
                                className="progress-bar"
                                style={{
                                  width: `${eq.occupancyRate}%`,
                                  backgroundColor: eq.occupancyRate >= 100 ? COR_PERIGO : COR_PRIMARIA,
                                }}
                              />
                            </div>
                            <small className="text-muted">{eq.occupancyRate.toFixed(0)}%</small>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </DataTable>
                </Card.Body>
              </Card>
            </>
          )}
        </Tab>

        {/* ─── ABA: Mapa ─── 🆕 com botão de tela cheia */}
        <Tab eventKey="map" title={<><FaMap className="me-2" />Mapa</>}>
          <Card className="shadow-sm">
            <Card.Header className="bg-white fw-semibold d-flex justify-content-between align-items-center">
              <span>
                <FaMapMarkerAlt className="me-2" style={{ color: COR_PRIMARIA }} />
                Localização dos Equipamentos ({equipmentsWithCoords.length})
              </span>

              <Button
                size="sm"
                variant="outline-primary"
                onClick={toggleMapFullscreen}
                disabled={equipmentsWithCoords.length === 0}
                title={isMapFullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
              >
                {isMapFullscreen ? <FaCompress className="me-1" /> : <FaExpand className="me-1" />}
                {isMapFullscreen ? 'Sair' : 'Tela cheia'}
              </Button>
            </Card.Header>

            <Card.Body>
              {loading ? (
                <div className="text-center my-5">
                  <Spinner animation="border" variant="primary" />
                  <p className="text-muted mt-2">Carregando mapa...</p>
                </div>
              ) : equipmentsWithCoords.length > 0 ? (
                <div
                  ref={mapContainerRef}
                  style={{
                    width: '100%',
                    height: isMapFullscreen ? '100%' : 500,
                    background: '#fff',
                  }}
                >
                  <EquipmentMap equipments={equipmentsWithCoords} />
                </div>
              ) : (
                <p className="text-center text-muted my-4">
                  📍 Nenhum equipamento com coordenadas cadastradas.
                </p>
              )}
            </Card.Body>
          </Card>
        </Tab>

      </Tabs>

      <EquipmentDetailModal
        equipment={selectedEquipment}
        onClose={() => setSelectedEquipment(null)}
      />
    </Container>
  );
}

// ==========================================
// CARD DE RANKING
// ==========================================
interface RankingCardProps {
  title:    string;
  icon:     React.ReactNode;
  color:    string;
  rows:     EquipmentRow[];
  loading:  boolean;
  variant:  'top' | 'bottom';
  onSelect: (eq: EquipmentRow) => void;
}

function RankingCard({ title, icon, color, rows, loading, variant, onSelect }: RankingCardProps) {
  return (
    <Card className="border-0 shadow-sm h-100">
      <Card.Header className={`bg-${color} bg-opacity-10 text-${color} fw-semibold d-flex align-items-center gap-2`}>
        {icon} {title}
      </Card.Header>
      <Card.Body className="p-0">
        <DataTable
          columns={['#', 'Equipamento', 'Pedidos', 'Receita', 'Ações']}
          loading={loading}
          emptyMessage="Nenhum equipamento encontrado."
        >
          {rows.length > 0 && rows.map((row, idx) => (
            <tr key={row.equipmentId}>
              <td className="text-center">
                <RankNumber position={idx + 1} variant={variant} />
              </td>
              <td>
                <div className="fw-semibold d-flex align-items-center gap-2">
                  <FaTv className="text-muted" />
                  {row.name}
                </div>
                <small className="text-muted">
                  <code>{row.identifierCode}</code> · {row.category}
                </small>
              </td>
              <td className="text-center">
                <span className="fw-bold" style={{ color: row.ordersCount === 0 ? COR_PERIGO : undefined }}>
                  {row.ordersCount}
                </span>
              </td>
              <td className="fw-semibold">{formatCurrency(row.totalRevenue)}</td>
              <td>
                <Button size="sm" variant="outline-primary" onClick={() => onSelect(row)} disabled={row.ordersCount === 0}>
                  <FaEye />
                </Button>
              </td>
            </tr>
          ))}
        </DataTable>
      </Card.Body>
    </Card>
  );
}

// ==========================================
// MODAL DE DETALHE
// ==========================================
interface DetailModalProps {
  equipment: EquipmentRow | null;
  onClose:   () => void;
}

function EquipmentDetailModal({ equipment, onClose }: DetailModalProps) {
  if (!equipment) return null;

  const monthlyData = equipment.monthlyRevenue.map(m => ({
    ...m,
    monthLabel: formatMonth(m.month),
  }));

  return (
    <Modal show={!!equipment} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <FaTv />
          {equipment.name}
          <CategoryTag>{equipment.category}</CategoryTag>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3 g-2">
          <Col md={3}>
            <Card className="bg-primary bg-opacity-10 border-0 text-center p-2">
              <small className="text-muted">Pedidos</small>
              <h4 className="mb-0 text-primary">{equipment.ordersCount}</h4>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="bg-success bg-opacity-10 border-0 text-center p-2">
              <small className="text-muted">Receita</small>
              <h6 className="mb-0 text-success">{formatCurrency(equipment.totalRevenue)}</h6>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="bg-info bg-opacity-10 border-0 text-center p-2">
              <small className="text-muted">Ticket Médio</small>
              <h6 className="mb-0 text-info">{formatCurrency(equipment.avgTicket)}</h6>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="bg-warning bg-opacity-10 border-0 text-center p-2">
              <small className="text-muted">Clientes</small>
              <h4 className="mb-0 text-warning">{equipment.uniqueCustomers}</h4>
            </Card>
          </Col>
        </Row>

        <h6 className="text-muted mb-3">
          <FaChartBar className="me-2" />
          Faturamento por Mês
        </h6>
        {monthlyData.length > 0 ? (
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="monthLabel" />
              <YAxis tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`} />
              <Tooltip formatter={(v: number) => formatCurrency(v)} />
              <Bar dataKey="revenue" name="Receita" fill={COR_PRIMARIA} radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-center text-muted my-3">Sem histórico mensal.</p>
        )}

        <hr />
        <Row className="small">
          <Col md={6}>
            <strong>📍 Localização:</strong> {equipment.location}<br />
            <strong>🔢 Código:</strong> <code>{equipment.identifierCode}</code><br />
            <strong>🎯 Slots:</strong> {equipment.slots}
          </Col>
          <Col md={6}>
            <strong>💰 Pago:</strong> <span className="text-success">{formatCurrency(equipment.paidRevenue)}</span><br />
            <strong>⏳ Pendente:</strong> <span className="text-warning">{formatCurrency(equipment.pendingRevenue)}</span><br />
            <strong>⚠️ Em atraso:</strong> <span className="text-danger">{formatCurrency(equipment.overdueRevenue)}</span>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
